import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { Locale } from '@shared/models/locale';
import { takeUntil, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import { StatsMosService } from '@shared/services/stats-mos.service';
import { TakeUntilDestroy } from '@utils/auto-unsubscribe';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class FooterComponent implements OnInit {
  public componentDestroy: () => Subject<any>;
  public icons = CustomIcons;
  public isRuLocale = true;
  public langChange$: Observable<LangChangeEvent>;

  constructor(private translateService: TranslateService, private statsMosService: StatsMosService) {}

  private setLocale(lang: Locale): void {
    if (lang === Locale.RU_RU) {
      this.isRuLocale = true;
    } else {
      this.isRuLocale = false;
    }
  }

  public ngOnInit(): void {
    this.setLocale(this.translateService.currentLang as Locale);
    this.langChange$ = this.translateService.onLangChange.pipe(
      tap(res => {
        this.setLocale(res.lang as Locale);
      })
    );
  }

  public statEvent(): void {
    this.statsMosService
      .fireEvent({ action: 'questionhpsm' })
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe({
        error: err => {
          if (err.status !== 200) {
            throw err;
          }
        }
      });
  }
}
